import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import {
  Form,
  FormHeader,
  Button,
  Role,
  TextfieldElement,
  TextareaElement,
  SelectElement,
  DateISO8601Element,
  AutocompleteTagsElement,
  CheckboxesElement,
  withAuthentication,
  withProvidersApi,
  withQualificationsApi,
  withCourseGroupsApi,
  AutocompleteTextfieldApiElement
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import i18n from "../../../i18n";
import { COURSE_TITLE_FIELD_QUALIFICATION, COURSE_TITLE_FIELD_COURSE, ROLE_STAFF, ROLE_PROVIDER, OPERATION_CREATE, OPERATION_EDIT } from '../../../constants';
import ErrorNavigation from '../../../components/ErrorNavigation';
import WysiwygElement from '../../../components/WysiwygElement';

class CoursesDetailsForm extends Component {

  constructor(props) {
    super(props);

    this.handleSetQualificationTitle = this.handleSetQualificationTitle.bind(this);
    this.handlePopulateFieldsFromProgramme = this.handlePopulateFieldsFromProgramme.bind(this);
  }

  // componentDidMount() {
  //   if (this.props.location.hash) {
  //     this.props.handleScrollToElement(this.props.location.hash.substring(1));
  //   }
  // }

  // componentDidUpdate(prevProps) {
  //   if (this.props.location.hash !== prevProps.location.hash) {
  //     this.props.handleScrollToElement(this.props.location.hash.substring(1));
  //   }
  // }

  filterProgrammesByCourseGroupType(id) {
    const programmes = this.props.courses.assets.courses.programmes[i18n.language];

    // Apprenticeships.
    if (id === '267040002') {
      return programmes.filter(programme => (programme.value === '267040003' || programme.value === '267040004' || programme.value === '267040005'));
    }

    // Jobs Growth Wales.
    if (id === '267040003') {
      return programmes.filter(programme => (programme.value === '267040000' || programme.value === '267040001' /*|| programme.value === '267040005'*/));
    }

    // Work ready.
    if (id === '267040004') {
      return programmes.filter(programme => (programme.value === '267040002'));
    }

    return programmes;
  }

  handleSetQualificationTitle(e) {
    this.props.handleChange(e);

    const qualificationEventname = e.target.name;
    const qualificationEventValue = e.target.value;

    if (qualificationEventname === 'qualificationTitleId' && qualificationEventValue) {
      this.props.qualificationsApiGetQualifications(qualificationEventValue, i18n.language, (response) => {
        const qualification = response.data[0];

        let qualifications = this.props.qualifications;

        // Add qualification if ID is valid and does not exist in array.
        if (!qualifications.some(qualification => qualification.id === qualificationEventValue)) {
          qualifications.push(qualification);

          this.props.handleSet('qualifications', qualifications);
        }

        // Set course title to qualification label.
          this.props.handleSet('title_en', qualification.title.en);
          this.props.handleSet('title_cy', qualification.title.cy);
          this.props.handleSet('qualificationTitleLabel_en', qualification.title.en);
          this.props.handleSet('qualificationTitleLabel_cy', qualification.title.cy);
      }, (error) => {
        console.error(error);
      });
    }
  }

  handlePopulateFieldsFromProgramme(e) {
    this.props.handleChange(e);

    const programmes = this.props.courses.assets.courses.programmes;
    const programmeId = e.target.value;
    const programmeEn = programmes.en.find(programme => programme.value === programmeId);
    const programmeCy = programmes.cy.find(programme => programme.value === programmeId);

    if (programmeEn && programmeCy) {
      const programmeFieldsEn = programmeEn.fields;
      const programmeFieldsCy = programmeCy.fields;

      // let sessions = this.props.sessions;
      let sessions = [];

      const session = {
        uuid: uuidv4(),
        id: sessions.length + 1,
        startDate: '',
        startDetails: {},
        daysTimes: {},
        studyMethodType: [],
        studyMethodHours: [],
        studyMethodTimes: [],
        // contact: {},
        venues: []
      };

      session.startDetails.en = programmeFieldsEn.startDetails;
      session.startDetails.cy = programmeFieldsCy.startDetails;

      sessions.push(session);

      this.props.handleSet({
        sessions: sessions,
        ['summary_en']: programmeFieldsEn.summary,
        ['duration_en']: programmeFieldsEn.duration,
        ['entry_en']: programmeFieldsEn.entry,
        ['additionalDetails_en']: programmeFieldsEn.additionalDetails,
        ['summary_cy']: programmeFieldsCy.summary,
        ['duration_cy']: programmeFieldsCy.duration,
        ['entry_cy']: programmeFieldsCy.entry,
        ['additionalDetails_cy']: programmeFieldsCy.additionalDetails
      });
    }
  }

  render() {
    const isWorkBasedLearningCourse = ['267040002', '267040003', '267040004'].includes(this.props.courseGroupTypeId);

    return (
      <Form>
        <ErrorNavigation field={this.props.errorActiveField} handleClearActiveErrors={this.props.handleClearActiveErrors} />
        <FormHeader title={this.props.t('local:view.courses.create.tabs.courseDetails.title')}
          introduction={this.props.t('local:view.courses.create.tabs.courseDetails.introduction')}>
          <Role roles={[ROLE_STAFF]}>
            <p dangerouslySetInnerHTML={{ __html: this.props.t('local:view.courses.create.tabs.courseDetails.mandatoryPromptStaff') }} />
          </Role>
          <Role roles={[ROLE_PROVIDER]}>
            <p dangerouslySetInnerHTML={{ __html: this.props.t('local:view.courses.create.tabs.courseDetails.mandatoryPromptProvider') }} />
          </Role>
        </FormHeader>

        {/* Qualification title */}
        {(this.props.mode === OPERATION_CREATE && this.props.titleField === COURSE_TITLE_FIELD_QUALIFICATION) &&
          <AutocompleteTextfieldApiElement
            size={'medium'}
            name={'qualificationTitle'}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.qualificationTitle.label')}
            placeholder={this.props.t('local:view.courses.create.tabs.courseDetails.field.qualificationTitle.placeholder')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.qualificationTitle.description')}
            suffix={
              <Button asLink={true} classes={['button', 'button--suffix']} onClick={(e) => this.props.handleSetTitleField(e, COURSE_TITLE_FIELD_COURSE)}>
                {this.props.t('local:view.courses.create.tabs.courseDetails.field.qualificationTitle.callToAction')}
              </Button>
            }
            hasButton={true}
            api={this.props.qualificationsApiGetEndpoint('qualifications_api_qualifications_mq')}
            authorize={true}
            queryParameter={'search'}
            keyField={'qualificationNumber'}
            valueField={'title'}
            dataFields={['qwApprovalDesignationNo', 'title']}
            keyword={this.props['qualificationTitleLabel_' + this.props.inputLanguage]}
            acceptLanguage={i18n.language}
            value={this.props['qualificationTitleId']}
            errors={this.props.errors['qualificationTitleId']}
            onChange={this.handleSetQualificationTitle}
            required={true} />
        }

        {/* Course title */}
        {(this.props.mode === OPERATION_EDIT || this.props.titleField === COURSE_TITLE_FIELD_COURSE) &&
          <TextareaElement
            size={'full-width'}
            id={'title_' + this.props.inputLanguage}
            name={'title_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitle.label')}
            advancedDescription={{
              link: { text: this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitle.advancedDescription.text') },
              body: this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitle.advancedDescription.body')
            }}
            suffix={
              <Role roles={[ROLE_PROVIDER]}>
                <Button asLink={true} classes={['button', 'button--suffix']} onClick={(e) => this.props.handleSetTitleField(e, COURSE_TITLE_FIELD_QUALIFICATION)}>
                  {this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitle.callToAction')}
                </Button>
              </Role>
            }
            hasButton={true}
            value={this.props['title_' + this.props.inputLanguage]}
            errors={this.props.errors['title_' + this.props.inputLanguage]}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter}
            required={true} />
        }

        {/* Course title abbreviation */}
        <Role roles={[ROLE_STAFF]}>
          <TextfieldElement
            size={'medium'}
            id={'abbreviatedTitle_' + this.props.inputLanguage}
            name={'abbreviatedTitle_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitleAbbreviation.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitleAbbreviation.description')}
            advancedDescription={{
              link: { text: this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitleAbbreviation.advancedDescription.text') },
              body: this.props.t('local:view.courses.create.tabs.courseDetails.field.courseTitleAbbreviation.advancedDescription.body')
            }}
            value={this.props['abbreviatedTitle_' + this.props.inputLanguage]}
            errors={this.props.errors['abbreviatedTitle_' + this.props.inputLanguage]}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter} />
        </Role>

        {/* Main provider */}
        <Role roles={[ROLE_STAFF]}>
          <AutocompleteTextfieldApiElement
            size={'medium'}
            name={'mainProvider'}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.mainProvider.label')}
            placeholder={this.props.t('local:view.courses.create.tabs.courseDetails.field.mainProvider.placeholder')}
            advancedDescription={{
              link: { text: this.props.t('local:view.courses.create.tabs.courseDetails.field.mainProvider.advancedDescription.text') },
              body: this.props.t('local:view.courses.create.tabs.courseDetails.field.mainProvider.advancedDescription.body')
            }}
            api={this.props.providersApiGetEndpoint('providers_api_provider')}
            authorize={true}
            queryParameter={'name'}
            keyField={'atlasAccountId'}
            valueField={'providerName'}
            keyword={this.props.mainProviderLabel}
            acceptLanguage={i18n.language}
            value={this.props['mainProviderId']}
            errors={this.props.errors['mainProviderId']}
            onChange={this.props.handleChange}
            required={true}
            disabled={this.props.mode === OPERATION_EDIT} />
        </Role>

        {/* Main provider disabled */}
        <Role roles={[ROLE_PROVIDER]}>
          <TextfieldElement
            size={'medium'}
            id={'mainProviderDisabled'}
            name={'mainProviderDisabled'}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.mainProvider.label')}
            value={this.props['mainProviderLabel']}
            required={true}
            disabled={true} />
        </Role>

        {/* Course group name */}
        {(this.props['courseGroupId'] || (this.props.mainProviderId || this.props.errors['courseGroup.id'])) &&
          <AutocompleteTextfieldApiElement
            size={'medium'}
            anchorId={'courseGroup.id'}
            name={'courseGroup'}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseGroupName.label')}
            placeholder={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseGroupName.placeholder')}
            advancedDescription={{
              link: { text: this.props.t('local:view.courses.create.tabs.courseDetails.field.courseGroupName.advancedDescription.text') },
              body: this.props.t('local:view.courses.create.tabs.courseDetails.field.courseGroupName.advancedDescription.body')
            }}
            api={this.props.courseGroupsApiGetEndpoint('course_groups_api_course_groups_mq')}
            authorize={true}
            queryParameter={'search'}
            additionalParameters={{
              'atlasAccountId': this.props['mainProviderId'],
              ...(this.props.authentication.hasRole(ROLE_PROVIDER) && { 'courseGroupTypeId': ['267040002', '267040003', '267040004'] })
            }}
            keyField={'courseGroupId'}
            valueField={'courseGroupName'}
            dataFields={['courseGroupName', 'courseGroupType']}
            dataFieldsSeparator={' - '}
            keyword={this.props['courseGroupLabel']}
            acceptLanguage={i18n.language}
            value={this.props['courseGroupId']}
            errors={this.props.errors['courseGroup.id']}
            onChange={(e) => this.props.handleSet({
              [e.target.name]: e.target.value,
              // Clear course group type ID if the course group ID has cleared.
              ...((e.target.name === 'courseGroupId' && !e.target.value) && { courseGroupTypeId: '' })
            })}
            onSelected={(option) => this.props.handleSet({
              courseGroupId: option.courseGroupId,
              courseGroupName: option.courseGroupName,
              courseGroupTypeId: option.courseGroupTypeId
            })}
            required={true}
            disabled={this.props.mode === OPERATION_EDIT} />
        }

        {/* Course content */}
        <WysiwygElement
          id={'content_' + this.props.inputLanguage}
          name={'content_' + this.props.inputLanguage}
          label={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseContent.label')}
          description={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseContent.description')}
          value={this.props['content_' + this.props.inputLanguage]}
          errors={this.props.errors['content_' + this.props.inputLanguage]}
          onChange={(e) => this.props.handleSet('content_' + this.props.inputLanguage, e.data.get())}
          required={true} />

        {/* Programme */}
        {(this.props.mode === OPERATION_CREATE && (this.props['courseGroupId'] || this.props.errors['programme'])) &&
          <Role roles={[ROLE_PROVIDER]}>
            <SelectElement
              size={'medium'}
              id={'programme'}
              name={'programme'}
              label={this.props.t('local:view.courses.create.tabs.courseDetails.field.programme.label')}
              description={this.props.t('local:view.courses.create.tabs.courseDetails.field.programme.description')}
              options={[{
                value: '',
                label: this.props.t('styleguide:forms.pleaseSelect')
              }].concat(this.filterProgrammesByCourseGroupType(this.props.courseGroupTypeId))}
              value={this.props['programme']}
              errors={this.props.errors['programme']}
              onChange={this.handlePopulateFieldsFromProgramme}
              onKeyPress={this.context.preventDefaultOnEnter}
              required={true} />
          </Role>
        }

        {/* Programme disabled */}
        {(this.props.mode === OPERATION_EDIT && isWorkBasedLearningCourse) &&
          <SelectElement
            size={'medium'}
            id={'programme'}
            name={'programme'}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.programme.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.programme.description')}
            options={[{
              value: '',
              label: this.props.t('styleguide:forms.pleaseSelect')
            }].concat(this.filterProgrammesByCourseGroupType(this.props.courseGroupTypeId))}
            value={this.props['programme']}
            errors={this.props.errors['programme']}
            onChange={this.handlePopulateFieldsFromProgramme}
            onKeyPress={this.context.preventDefaultOnEnter}
            required={true}
            disabled={true} />
        }

        {/* Summary */}
        {!isWorkBasedLearningCourse &&
          <Role roles={[ROLE_STAFF]}>
            <WysiwygElement
              id={'summary_' + this.props.inputLanguage}
              name={'summary_' + this.props.inputLanguage}
              label={this.props.t('local:view.courses.create.tabs.courseDetails.field.summary.label')}
              description={this.props.t('local:view.courses.create.tabs.courseDetails.field.summary.description')}
              value={this.props['summary_' + this.props.inputLanguage]}
              errors={this.props.errors['summary_' + this.props.inputLanguage]}
              onChange={(e) => this.props.handleSet('summary_' + this.props.inputLanguage, e.data.get())}
              required={true} />
          </Role>
        }

        {/* Summary disabled */}
        {(this.props['programme'] && isWorkBasedLearningCourse) &&
          <WysiwygElement
            id={'summary_' + this.props.inputLanguage}
            name={'summary_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.summary.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.summary.description')}
            value={this.props['summary_' + this.props.inputLanguage]}
            errors={this.props.errors['summary_' + this.props.inputLanguage]}
            onChange={(e) => this.props.handleSet('summary_' + this.props.inputLanguage, e.data.get())}
            required={true}
            disabled={true} />
        }

        {/* Duration */}
        {!isWorkBasedLearningCourse &&
          <Role roles={[ROLE_STAFF]}>
            <TextareaElement
              size={'full-width'}
              id={'duration_' + this.props.inputLanguage}
              name={'duration_' + this.props.inputLanguage}
              label={this.props.t('local:view.courses.create.tabs.courseDetails.field.duration.label')}
              description={this.props.t('local:view.courses.create.tabs.courseDetails.field.duration.description')}
              value={this.props['duration_' + this.props.inputLanguage]}
              errors={this.props.errors['duration_' + this.props.inputLanguage]}
              onChange={this.props.handleChange}
              onKeyPress={this.context.preventDefaultOnEnter} />
          </Role>
        }

        {/* Duration disabled */}
        {(this.props['programme'] && isWorkBasedLearningCourse) &&
          <TextareaElement
            size={'full-width'}
            id={'duration_' + this.props.inputLanguage}
            name={'duration_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.duration.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.duration.description')}
            value={this.props['duration_' + this.props.inputLanguage]}
            errors={this.props.errors['duration_' + this.props.inputLanguage]}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter}
            disabled={true} />
        }

        {/* Entry requirements */}
        {!isWorkBasedLearningCourse &&
          <Role roles={[ROLE_STAFF]}>
            <WysiwygElement
              id={'entry_' + this.props.inputLanguage}
              name={'entry_' + this.props.inputLanguage}
              label={this.props.t('local:view.courses.create.tabs.courseDetails.field.entryRequirements.label')}
              description={this.props.t('local:view.courses.create.tabs.courseDetails.field.entryRequirements.description')}
              value={this.props['entry_' + this.props.inputLanguage]}
              errors={this.props.errors['entry_' + this.props.inputLanguage]}
              onChange={(e) => this.props.handleSet('entry_' + this.props.inputLanguage, e.data.get())}
              required={true} />
          </Role>
        }

        {/* Entry requirements disabled */}
        {(this.props['programme'] && isWorkBasedLearningCourse) &&
          <WysiwygElement
            id={'entry_' + this.props.inputLanguage}
            name={'entry_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.entryRequirements.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.entryRequirements.description')}
            value={this.props['entry_' + this.props.inputLanguage]}
            errors={this.props.errors['entry_' + this.props.inputLanguage]}
            onChange={(e) => this.props.handleSet('entry_' + this.props.inputLanguage, e.data.get())}
            required={true}
            disabled={true} />
        }

        {/* Additional details */}
        {(this.props.mode === OPERATION_EDIT && (this.props['additionalDetails_en'] || this.props['additionalDetails_cy']) && !isWorkBasedLearningCourse) &&
          <Role roles={[ROLE_STAFF]}>
            <WysiwygElement
              id={'additionalDetails_' + this.props.inputLanguage}
              name={'additionalDetails_' + this.props.inputLanguage}
              label={this.props.t('local:view.courses.create.tabs.courseDetails.field.additionalDetails.label')}
              description={this.props.t('local:view.courses.create.tabs.courseDetails.field.additionalDetails.description')}
              value={this.props['additionalDetails_' + this.props.inputLanguage]}
              errors={this.props.errors['additionalDetails_' + this.props.inputLanguage]}
              onChange={(e) => this.props.handleSet('additionalDetails_' + this.props.inputLanguage, e.data.get())} />
          </Role>
        }

        {/* Additional details disabled */}
        {(this.props['programme'] && isWorkBasedLearningCourse) &&
          <WysiwygElement
            id={'additionalDetails_' + this.props.inputLanguage}
            name={'additionalDetails_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.additionalDetails.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.additionalDetails.description')}
            value={this.props['additionalDetails_' + this.props.inputLanguage]}
            errors={this.props.errors['additionalDetails_' + this.props.inputLanguage]}
            onChange={(e) => this.props.handleSet('additionalDetails_' + this.props.inputLanguage, e.data.get())}
            disabled={true} />
        }

        {/* Enrolment details */}
        <WysiwygElement
          id={'enrolment_' + this.props.inputLanguage}
          name={'enrolment_' + this.props.inputLanguage}
          label={this.props.t('local:view.courses.create.tabs.courseDetails.field.enrolmentDetails.label')}
          description={this.props.t('local:view.courses.create.tabs.courseDetails.field.enrolmentDetails.description')}
          value={this.props['enrolment_' + this.props.inputLanguage]}
          errors={this.props.errors['enrolment_' + this.props.inputLanguage]}
          onChange={(e) => this.props.handleSet('enrolment_' + this.props.inputLanguage, e.data.get())} />

        {/* Cost */}
        <Role roles={[ROLE_STAFF]}>
          <TextareaElement
            size={'full-width'}
            id={'cost_' + this.props.inputLanguage}
            name={'cost_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.cost.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.cost.description')}
            value={this.props['cost_' + this.props.inputLanguage]}
            errors={this.props.errors['cost_' + this.props.inputLanguage]}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter} />
        </Role>

        {/* Course language */}
        <AutocompleteTagsElement
          size={'medium'}
          id={'languages'}
          name={'languages'}
          label={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseLanguage.label')}
          description={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseLanguage.description')}
          placeholder={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseLanguage.placeholder')}
          callToAction={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseLanguage.callToAction')}
          options={this.props.courses.assets.courses.languages[i18n.language].map(language => ({ id: language.value, value: language.label }))}
          value={this.props.languages}
          errors={this.props.errors.languages}
          onChange={this.props.handleChange} />

        {/* Course type */}
        <CheckboxesElement
          id={'courseType'}
          name={'courseType'}
          label={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseType.label')}
          description={this.props.t('local:view.courses.create.tabs.courseDetails.field.courseType.description')}
          options={this.props.courses.assets.courses.courseType[i18n.language]}
          value={this.props['courseType']}
          onChange={this.props.handleChange} />

        {/* Review date */}
        <Role roles={[ROLE_STAFF]}>
          <DateISO8601Element
            id={'reviewDate'}
            name={'reviewDate'}
            label={this.props.t('local:view.courses.create.tabs.courseDetails.field.reviewDate.label')}
            description={this.props.t('local:view.courses.create.tabs.courseDetails.field.reviewDate.description')}
            value={this.props['reviewDate']}
            errors={this.props.errors['reviewDate']}
            onChange={this.props.handleChange}
            required={true} />
        </Role>

      </Form>
    );
  }

}

export default withAuthentication(withCourseGroupsApi(process.env)(withQualificationsApi(process.env)(withProvidersApi(process.env)(withAssets(withTranslation('local')(CoursesDetailsForm))))));
